// axios config 
export default {
    baseURL: 'https://www.sait.ca/api'
}